export const ROLES_FETCH_BEGIN = 'syftacp/ROLES_FETCH_BEGIN'
export const ROLES_FETCH_FAILED = 'syftacp/ROLES_FETCH_FAILED'
export const ROLES_FETCH_SUCCEEDED = 'syftacp/ROLES_FETCH_SUCCEEDED'
